export default {
  ADMIN: 1,
  MERCHANT: 10,
  MEMBER: 100,
};
